import { todayISODate } from "../utils/homepageSeason";

export const FIND_LIST_ABANDONED_AFTER_DAYS = 30;
export const FIND_LIST_FAR_FUTURE_DAYS = 90;
export const FIND_LIST_ID_CHUNK = 80;

export const FIND_LIST_SELECT = `
            *,
            tournamentEvents (
              eventName,
              bowlerQuantity,
              isPrimary
            ),
            organizations (
              id,
              name
            ),
            squads (
              id,
              isDeleted,
              squadDate,
              bowlingCenters (
                id,
                centerName
              )
            )
          `;

const addIsoDays = (isoDate, days) => {
  const [year, month, day] = String(isoDate).split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

const scheduledSquads = (tournament) =>
  (tournament?.squads || []).filter(
    (squad) =>
      !squad.isDeleted && Boolean(squad.squadDate) && Boolean(squad.squadTime)
  );

export const isVisibleOnFindList = (
  tournament,
  { today, hasScores = false } = {}
) => {
  if (!tournament || tournament.isDeleted || tournament.deletedAt) return false;
  if (tournament.organizations?.isTest) return false;

  const live = scheduledSquads(tournament);
  if (live.length === 0) return false;

  const dates = live
    .map((squad) => squad.squadDate)
    .filter(Boolean)
    .sort();
  const firstStart = dates[0];
  const lastStart = dates[dates.length - 1];
  if (!firstStart || !lastStart) return false;

  if (firstStart > addIsoDays(today, FIND_LIST_FAR_FUTURE_DAYS)) return false;
  if (
    lastStart < addIsoDays(today, -FIND_LIST_ABANDONED_AFTER_DAYS) &&
    !hasScores
  ) {
    return false;
  }
  return true;
};

const chunkIds = (ids) => {
  const chunks = [];
  for (let index = 0; index < ids.length; index += FIND_LIST_ID_CHUNK) {
    chunks.push(ids.slice(index, index + FIND_LIST_ID_CHUNK));
  }
  return chunks;
};

export const fetchFindListTournaments = async (
  supabase,
  today = todayISODate()
) => {
  const { data: idRows, error: idError } = await supabase.rpc(
    "find_list_tournament_ids",
    { p_today: today }
  );
  if (idError) return { data: null, error: idError };

  const ids = (idRows || [])
    .map((row) => (typeof row === "string" ? row : row?.id))
    .filter(Boolean);
  if (ids.length === 0) return { data: [], error: null };

  const pages = await Promise.all(
    chunkIds(ids).map((chunk) =>
      supabase
        .from("tournaments")
        .select(FIND_LIST_SELECT)
        .in("id", chunk)
        .is("isDeleted", false)
    )
  );

  for (const page of pages) {
    if (page.error) return { data: null, error: page.error };
  }

  const data = pages
    .flatMap((page) => page.data || [])
    .sort((left, right) => new Date(right.startDate) - new Date(left.startDate));
  return { data, error: null };
};
